/* unplugin-vue-components disabled */import script from "./TeachingCenterList.vue?vue&type=script&setup=true&lang=js"
export * from "./TeachingCenterList.vue?vue&type=script&setup=true&lang=js"

import "./TeachingCenterList.vue?vue&type=style&index=0&id=2814ca26&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/外网-成都工业学院-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2814ca26"]])

export default __exports__